import { LucideChevronDown, LucideChevronUp } from 'lucide-react'
import { aUser, useAtomValue } from '~/atoms'
import { Button, Separator } from '~/components/ui'
import { useLocalStorage } from '~/hooks'
import { PROPERTY_TYPES_COLORS, cn } from '~/utils'

export default function MapLegend({ className }: { className?: string }) {
  const user = useAtomValue(aUser)
  const [isLegendVisible, setIsLegendVisible] = useLocalStorage(
    'isLegendVisible',
    true
  )

  return (
    <div
      id="map-legend"
      className={cn(
        'absolute right-4 z-50 w-26 rounded-md bg-background text-xs shadow-md',
        user ? 'bottom-20' : 'bottom-6',
        className
      )}>
      <div className="flex">
        {isLegendVisible === true && (
          <div className="space-y-1 px-2 py-1" id="legend-content">
            <div className="flex items-center gap-2">
              <span className="legend-triangle" />
              <span className="text-xs">Sale</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-[#c026d3]" />
              <span className="text-xs">Lease</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 bg-[#4f46e5]" />
              <span className="text-xs">Sale/Lease</span>
            </div>
            <div className="flex items-center gap-2">
              <BusinessListingIcon className="-mx-[2px] h-4 w-4" />
              <span className="text-xs">Business</span>
            </div>
            <Separator className="!my-2" />
            {PROPERTY_TYPES_COLORS.map(({ propertyType, className }, index) => (
              <div key={index} className="flex items-center gap-2">
                <span className={cn('h-3 w-3 rounded-full', className)} />
                <span className="text-xs">{propertyType}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Button
        variant="ghost"
        onClick={() => setIsLegendVisible((prev) => !prev)}
        className="h-8 w-full justify-start px-1.5 text-xs">
        {isLegendVisible === true ? (
          <>
            <LucideChevronDown className="mr-1.5 h-4 w-4 pl-px" /> Hide Legend
          </>
        ) : (
          <>
            <LucideChevronUp className="mr-1.5 h-4 w-4 pl-px" /> Show Legend
          </>
        )}
      </Button>
    </div>
  )
}

function BusinessListingIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 210 199">
      <title>Polygon</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <path
          d="M105,17.3049517 L193.15823,81.3556548 L159.484782,184.991869 L50.5152176,184.991869 L16.8417703,81.3556548 L105,17.3049517 Z"
          id="Polygon"
          fill="#9A3412"></path>
      </g>
    </svg>
  )
}
